export default __webpack_public_path__ + "static/media/chat5.faa442e8.png";